import cx from 'classnames';
import { Anchor } from 'components/admin/ui';
import { ElementType } from 'react';
import css from './NavigationLink.module.scss';

interface INavigationLinkProps {
  className?: string;
  href: string;
  icon: ElementType;
  isActive: boolean;
  label: string;
}

export const NavigationLink = ({
  className,
  href,
  icon: Icon,
  isActive,
  label,
}: INavigationLinkProps) => (
  <Anchor
    aria-label={label}
    className={cx(css.navigationLink, className, {
      [css.isActive]: isActive,
    })}
    href={href}
  >
    <div className={css.iconContainer}>
      <Icon height={18} width={18} />
    </div>
    <span className={css.navigationLabel}>{label}</span>
  </Anchor>
);
